<template>
  <div>
    <nav class="s-bg-white s-rounded-md progress">
      <ul class="s-space-y-2 s-list-none s-text-left">
        <li
          v-for="(step, index) in steps"
          :key="step.id"
          class="s-flex s-items-center s-gap-2"
          :class="getStepClass(index)"
          @click="navigateTo(index)"
        >
          <!-- Icon based on step state -->
          <span
            class="s-flex s-items-center s-justify-center"
            style="width: 24px"
          >
            <s-icon
              v-if="index <= completedUntilStep"
              name="check-circle"
              class="s-text-primary-600"
            />
            <span
              v-else-if="index === currentStepIndex"
              style="width: 20px; height: 20px"
              class="current-outer-circle s-bg-gray-200 s-flex s-justify-center s-items-center s-rounded-full"
            >
              <span
                style="width: 10px; height: 10px"
                class="current-inner-circle s-rounded-full"
              ></span>
            </span>
            <!-- Next available step -->
            <span
              v-else-if="
                index === completedUntilStep + 1 && index !== currentStepIndex
              "
              style="width: 10px; height: 10px"
              class="s-rounded-full s-bg-neutral-200"
            ></span>
            <!-- Not completed steps -->
            <span
              v-else
              style="width: 10px; height: 10px"
              class="s-rounded-full s-bg-neutral-200"
            ></span>
          </span>

          <span>{{ step.label }}</span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
// Using namespaced Vuex modules
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStepIndex: {
      type: Number,
      required: true,
    },
    completedUntilStep: {
      type: Number,
      required: true,
    },
    disableClicks: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigateTo(index) {
      // Don't allow navigation if clicks are disabled
      if (this.disableClicks) {
        return;
      }
      
      // Only allow navigation to completed steps or the next available step
      if (
        index <= this.completedUntilStep + 1 &&
        index !== this.currentStepIndex
      ) {
        this.$emit('update:currentStep', index);
      }
    },
    getStepClass(index) {
      const classes = ['s-flex', 's-items-center', 's-gap-2'];

      // Text styling
      if (index === this.currentStepIndex) {
        classes.push('s-text-primary-600', 's-font-bold');
      } else {
        classes.push('s-text-neutral-600');
      }

      // Cursor styling
      if (this.disableClicks) {
        classes.push('s-cursor-not-allowed');
      } else if (index <= this.completedUntilStep + 1) {
        classes.push('s-cursor-pointer');
      } else {
        classes.push('s-cursor-not-allowed');
      }

      return classes.join(' ');
    },
  },
};
</script>
<style lang="scss">
.progress {
  & .current-inner-circle {
    background: $primary-600;
  }
}
</style>
